import React, { useState } from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import SideMenu from "../components/SideMenu";
import AppHeader from "../components/AppHeader";

const drawerWidth = 280;

const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", backgroundColor: "#f7f8f9", minHeight: "100vh" }}>
      
      {/* 1. HEADER - Il est en position fixed et prend 100% de large */}
      <AppHeader isMobile={isMobile} handleDrawerToggle={() => setMobileOpen(!mobileOpen)} />

      {/* 2. SIDEBAR - Elle commence plus bas grâce au margin dans SideMenu */}
      <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? mobileOpen : true}
          onClose={() => setMobileOpen(false)}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              border: "none",
              backgroundColor: "transparent",
              overflow: "visible",
            },
          }}
        >
          <SideMenu />
        </Drawer>
      </Box>

      {/* 3. CONTENU - Aligné avec le reste */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 3,
          mt: "110px", // Même valeur que la marge du SideMenu pour un alignement parfait
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;